export const layersConfig = [
    {
        title: 'ISO Market Points',
        description: `This layer represents pricing nodes in each of the ISOs. 
            Locations are not available for all nodes, so this displays only nodes with coordinates available. 
            Locations match the precision of the underlying source, primarily EIA and ISO publications. 
            Updated: March 2025`,
    },
    {
        title: 'Ascend ISO Forecasting Subregions',
        description: `This layer shows Ascend's forecasting regions within an ISO, which are based on Ascend's analysis of geospatial 
            boundaries and patterns that affect current and future resource buildout and price formation. 
            Updated: 2024`,
    },
];
